import UserSessionService from "../UserSessionService";
import UniversalTransaction from "../../domain/Transaction/UniversalTransaction";
import RawWsService from "../RawWsService";

const ENDPOINT_BASE = "/transactions/universal-transaction";

export default class UniversalTransactionService {

    static retrieveUniversalTransaction(registrationId, pageSize) {

        let endpoint = ENDPOINT_BASE + "?registration-id=" + registrationId;

        let transactionHeaders = UserSessionService.retrieveTransactingHeaders();

        let headers = {
            ...transactionHeaders,
            'x-page-size': pageSize,
            'x-sort-order': "DESC",
            'x-sort-by': "transactionDate"
        };
        return RawWsService.getWithHeaders(endpoint, {}, 200, headers).then(
            response => {
                let array = [];
                response.body.forEach(jsonTransaction => {
                    array.push(new UniversalTransaction(jsonTransaction));
                });
                return {"headers": response.headers, "body": array};
            },
            response => {
                return response;
            });

    }

}